import { CHECKOUT_VIEW } from 'core/domains';
import { checkout } from 'core/use-cases';
import { cartStepsPayload, cartBeginCheckout, cartPaymentOption } from './';
import type { RootState } from 'core/store';

export const cartSteps = (action: any, prevState: RootState) => {
  if (action.type === checkout.actions.paymentDetailFetch.request.type) {
    return cartStepsPayload('finalizar-pedido');
  }

  if (action.payload === CHECKOUT_VIEW.PAYMENT_CREDIT_CARD_FORM) {
    return cartStepsPayload('continuar');
  }

  if (action.payload === CHECKOUT_VIEW.SUMMARY) {
    return [
      cartStepsPayload('revisar-pedido'),
      cartBeginCheckout(prevState),
      cartPaymentOption(prevState),
    ];
  }
};
